import { KursblockungAlgorithmusPermanentK, cast_de_svws_nrw_core_kursblockung_KursblockungAlgorithmusPermanentK } from '../../core/kursblockung/KursblockungAlgorithmusPermanentK';
import { Random } from '../../java/util/Random';
import { GostBlockungsdatenManager } from '../../core/utils/gost/GostBlockungsdatenManager';
import { Class } from '../../java/lang/Class';
import { Logger } from '../../core/logger/Logger';
import { System } from '../../java/lang/System';

export class KursblockungAlgorithmusPermanentKMatching extends KursblockungAlgorithmusPermanentK {


	/**
	 * Im Konstruktor wird ein zufälliger Anfangszustand erzeugt.
	 *
	 * @param random   Ein {@link Random}-Objekt zur Steuerung des Zufalls über einen Anfangs-Seed.
	 * @param logger   Logger für Benutzerhinweise, Warnungen und Fehler.
	 * @param input    Die dynamischen Blockungsdaten.
	 */
	public constructor(random: Random, logger: Logger, input: GostBlockungsdatenManager) {
		super(random, logger, input);
		if (this.dynDaten.gibKurseDieFreiSindAnzahl() === 0) {
			return;
		}
		this.dynDaten.aktionSchuelerAusAllenKursenEntfernen();
		this.dynDaten.aktionKurseFreieZufaelligVerteilen();
		this.dynDaten.aktionSchuelerVerteilenMitGewichtetenBipartitemMatching();
		this.dynDaten.aktionZustandSpeichernK();
	}

	public toString(): string {
		return "KursblockungAlgorithmusPermanentKMatching";
	}

	public next(zeitEnde: number): void {
		const current: number = System.currentTimeMillis();
		const halbzeit: number = current + (Math.trunc((zeitEnde - current) / 2));
		do {
			this.verteileKurseMitMatching();
		} while (System.currentTimeMillis() < halbzeit);
		do {
			this.verteileKurseMitMatchingW();
		} while (System.currentTimeMillis() < zeitEnde);
	}

	private verteileKurseMitMatching(): void {
		do {
			this.dynDaten.aktionSchuelerAusAllenKursenEntfernen();
			this.dynDaten.aktionKursVerteilenEinenZufaelligenFreien();
			this.dynDaten.aktionSchuelerVerteilenMitBipartitemMatching();
			if (this.dynDaten.gibCompareZustandK1NW2KD3FW() > 0) {
				this.dynDaten.aktionZustandSpeichernK();
				return;
			}
		} while (this.rnd.nextBoolean());
		this.dynDaten.aktionZustandLadenK();
	}

	private verteileKurseMitMatchingW(): void {
		do {
			this.dynDaten.aktionSchuelerAusAllenKursenEntfernen();
			this.dynDaten.aktionKursVerteilenEinenZufaelligenFreien();
			this.dynDaten.aktionSchuelerVerteilenMitGewichtetenBipartitemMatching();
			if (this.dynDaten.gibCompareZustandK1NW2KD3FW() > 0) {
				this.dynDaten.aktionZustandSpeichernK();
				return;
			}
		} while (this.rnd.nextBoolean());
		this.dynDaten.aktionZustandLadenK();
	}

	public ladeBestMitSchuelerverteilung(): void {
		this.dynDaten.aktionZustandLadenK();
	}

	transpilerCanonicalName(): string {
		return 'de.svws_nrw.core.kursblockung.KursblockungAlgorithmusPermanentKMatching';
	}

	isTranspiledInstanceOf(name: string): boolean {
		return ['de.svws_nrw.core.kursblockung.KursblockungAlgorithmusPermanentKMatching', 'de.svws_nrw.core.kursblockung.KursblockungAlgorithmusPermanentK'].includes(name);
	}

	public static readonly class = new Class<KursblockungAlgorithmusPermanentKMatching>('de.svws_nrw.core.kursblockung.KursblockungAlgorithmusPermanentKMatching');

}

export function cast_de_svws_nrw_core_kursblockung_KursblockungAlgorithmusPermanentKMatching(obj: unknown): KursblockungAlgorithmusPermanentKMatching {
	return obj as KursblockungAlgorithmusPermanentKMatching;
}
